import React from 'react'
import ContentWizard from './group-edit/widget-content'
import UserWizard from './group-edit/widget-user'
import { GroupExternalID } from './group-edit/group-external-id'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { useApiFormGroup } from '../../../../../api-new/state/content'
import { useParamsInt } from '../../../../../shared/hooks/location'
import { Card } from '../../../../../shared/card/card'
import { TileBody, TileColumn11112 } from '../../../../../shared/tile/tile-column-21111'
import { IconActivityLog, IconContent, IconEdit, IconUser } from '../../../../../shared/icon/icon'
import { Menu, MenuDelete, MenuItem } from '../../../../../shared/menu/menu'
import { useAuditCapabilities } from '../../../../../shared/audit/use-audit-capabilities'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { useRoleOrgGroup, useRoleOrgGroupUser, useRoleOrgNodeGroup } from '../../../../../role/hook/role-org'
import { RoleOrgGroupUser, RoleOrgNodeGroup } from '../../../../../role/components/role-org'
import { FormNew } from '../../../../../shared/form-new/form'
import { FormNewText } from '../../../../../shared/form-new/form-text'
import { FormNewButtonUpdateBack } from '../../../../../shared/form-new/form-button'
import { MANAGED_GROUP_DELETE_NOTE, ManagedGroupChip, managedGroupNote, useManagedGroups } from '../../../../../shared/scim/managed-groups'
import { Notice } from '../../../../../shared/sso-workspace/fleet-page'

export function GroupEdit() {
  const { groupID } = useParamsInt()

  const apiFormGroup = useApiFormGroup()

  const roleOrgGroup = useRoleOrgGroup()
  const roleOrgNodeGroup = useRoleOrgNodeGroup()
  const roleOrgGroupUser = useRoleOrgGroupUser()
  const caps = useAuditCapabilities()
  // A group the identity provider manages (SCIM Groups): its name and
  // members are read-only here; course access and deletion stay.
  const { managed } = useManagedGroups({ enabled: roleOrgGroup.accessRead })
  const managedBy = managed(groupID)
  const isManaged = managedBy !== null

  const handlePath = async () => await apiFormGroup.get(groupID)
  const handleSubmit = async data => await apiFormGroup.put(groupID, data)

  const HeaderMenu = () =>
    <Menu>
      <MenuItem Icon={IconContent} text="contents" to={`/org/group/list/edit/${groupID}/content`} show={roleOrgNodeGroup.accessRead} />
      <MenuItem Icon={IconUser} text="users" to={`/org/group/list/edit/${groupID}/user`} show={roleOrgGroupUser.accessRead} />
      <MenuItem Icon={IconActivityLog} text="activity" to={`/org/group/list/edit/${groupID}/activity`} show={caps.canAudit} />
      <MenuDelete to={`/org/group/list/edit/${groupID}/delete`} show={roleOrgGroup.accessDelete} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text={apiFormGroup.form.name} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormGroup.form.name} HeaderMenu={HeaderMenu}>
          <TileBody>
            <TileColumn11112>
              {isManaged &&
                <div className="mb-3" data-testid="managed-group-notice">
                  <Notice tone="info">
                    <p className="mb-1"><ManagedGroupChip connectionName={managedBy} /></p>
                    <p className="mb-1">{managedGroupNote(managedBy)}</p>
                    {roleOrgGroup.accessDelete && <p className="sw-hint small m-0">{MANAGED_GROUP_DELETE_NOTE}</p>}
                  </Notice>
                </div>}
              <Card title="Group Edit">
                <FormNew state={apiFormGroup.form} enabled={roleOrgGroup.accessUpdate && !isManaged} onSubmit={handleSubmit} onRefresh={handlePath}>
                  <FormNewText name="name" autoFocus={!isManaged} required />
                  {!isManaged && <FormNewButtonUpdateBack backURL="/org/group/list" />}
                </FormNew>
              </Card>
              {!isManaged && <GroupExternalID groupID={groupID} />}
            </TileColumn11112>
            <TileColumn11112>
              <RoleOrgNodeGroup accessRead>
                <ContentWizard groupID={groupID} />
              </RoleOrgNodeGroup>
              <RoleOrgGroupUser accessRead>
                <UserWizard groupID={groupID} readOnly={isManaged} />
              </RoleOrgGroupUser>
            </TileColumn11112>
          </TileBody>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
